export const POLLING_INTERVAL = 10 * 60 * 1000; // 10 minutes in milliseconds
export const GET_RECENTLY_COMPLETED_TASKS_SERVICE_IDENTIFIER = 'getRecentlyCompletedTasksService';
export const GET_TASKS_IN_FOLDER_SERVICE_IDENTIFIER = 'getTasksInFolderService';
